import { useCallback, useState } from "react";
import { FaTimesCircle } from "react-icons/fa";
import CategoriesDropdown from "./categories-dropdown";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { useInjectReducer } from "../../../utils/injectReducer";
import { useInjectSaga } from "../../../utils/injectSaga";
import reducer from "./redux/reducer";
import saga from "./redux/saga";
import { useDispatch } from "react-redux";
import { addCategory } from "./redux/actions";

const key = "home_screen_categories";

export default function CreateCategory({ setShowForm, close }) {
  useInjectReducer({ key, reducer });
  useInjectSaga({ key, saga });
  const dispatch = useDispatch();

  const [preview, setPreview] = useState(null);
  //const [error, setError] = useState("");
  const [showCategories, setShowCategories] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [photo, setPhoto] = useState(null);

  const uploadPhoto = (e) => {
    let file = e.target.files[0];

    if (file) {
      if (file.size > 2000000) {
        //setError("Maksimalni limit slike je 2MB");
      } else {
        //setError("");
        setPhoto(file);
        setPreview(URL.createObjectURL(file));
      }
    }
  };

  const handleSubmit = () => {
    if (selectedCategory && photo) {
      const payload = { category_id: selectedCategory.id, photo };
      handleAddCategory(payload, close);
    }
  };

  const handleAddCategory = useCallback(
    (...args) => dispatch(addCategory(...args)),
    [dispatch]
  );

  return (
    <div className="fixed z-10 inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="relative flex flex-col  items-center w-[400px] rounded-lg gap-8 bg-white px-12 pt-12 pb-6 ">
        <span
          className="absolute top-2 right-4 cursor-pointer"
          onClick={() => setShowForm(false)}
        >
          &times;
        </span>
        <span className="text-2xl text-center">Dodaj novu kategoriju</span>
        <div>
          <input
            id="fileInput"
            type="file"
            name="image"
            className="hidden"
            onChange={uploadPhoto}
          ></input>
          {!preview && (
            <div
              className="flex items-center justify-center border border-dashed border-black border-opacity-20 h-[250px] w-[250px] p-8 rounded-lg cursor-pointer text-sm text-black text-opacity-40"
              onClick={() => document.getElementById("fileInput").click()}
            >
              Unesi sliku
            </div>
          )}

          {preview && (
            <div
              className="h-[250px] w-[250px]"
              style={{
                backgroundImage: `url(${preview})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover",
              }}
            >
              <FaTimesCircle onClick={() => setPreview(null)} />
            </div>
          )}
        </div>
        <div className="flex relative items-center h-full w-full pr-4 py-2 border border-black border-opacity-20 rounded-md text-sm text-black text-opacity-40 cursor-pointer">
          <div
            className="flex  items-center justify-between w-full"
            onClick={() => setShowCategories(!showCategories)}
          >
            <span className="pl-4 w-full">
              {selectedCategory ? selectedCategory.name : "Izaberi kategoriju"}
            </span>

            {showCategories ? (
              <MdKeyboardArrowUp className="ml-auto" />
            ) : (
              <MdKeyboardArrowDown className="ml-auto" />
            )}
          </div>
          {showCategories && (
            <CategoriesDropdown
              setSelectedCategory={setSelectedCategory}
              setShowCategories={setShowCategories}
            />
          )}
        </div>

        <button className="btn-primary" onClick={handleSubmit}>
          Dodaj
        </button>
      </div>
    </div>
  );
}
